<div class="survey-negative-container form-content">
  <div class="survey-negative-container__header">
    <span class="survey-negative-container__header__title"></span>
    <i (click)="onCloseSurvey()" class="icon-close icon-16"></i>
  </div>

  <span class="survey-negative-container__title">
    {{ questionTitle }}
  </span>

  @if (answerType === ETypes.Single) {
    <gcc-survey-negative-radio
      [options]="options"
      (onValueChanged)="handelSurveyNegativeRadio($event)"
    ></gcc-survey-negative-radio>
  }

  @if (answerType === ETypes.Multiple) {
    <gcc-survey-negative-checkbox
      [options]="options"
      (onValueChanged)="handelSurveyNegativeCheckbox($event)"
    ></gcc-survey-negative-checkbox>
    <div></div>
  }

  @if (isOther) {
    <div class="other">
      <form [formGroup]="form">
        <gcc-character-counter [withLimit]="500" gccValidation>
          <gcc-textarea-input [label]="''" formControlName="other" [maxLength]="500"></gcc-textarea-input>
        </gcc-character-counter>
      </form>
    </div>
  }

  <div class="survey-negative-container__actions">
    <button [disabled]="!isValid" class="btn btn-primary" (click)="onSubmit()">Submit</button>
  </div>
</div>
